import { render, staticRenderFns } from "./InQueue.vue?vue&type=template&id=88e5b500&scoped=true"
import script from "./InQueue.vue?vue&type=script&lang=js"
export * from "./InQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e5b500",
  null
  
)

export default component.exports